import { useNavigate } from 'react-router-dom';
import PageLayout from '@components/layout/PageLayout';
import styles from '../OattCoreInfoPage.module.css';

interface CoreInfoCard {
    icon: string;
    title: string;
    description: string;
    meta: { label: string; value: string }[];
    route: string;
    btnLabel: string;
}

const CARDS: CoreInfoCard[] = [
    {
        icon: '📊',
        title: 'Point-to-Point Rates',
        description:
            'Configure transmission service rates for point-to-point connections including firm and non-firm schedules, along with ancillary service pricing for various time periods.',
        meta: [
            { label: 'Schedules', value: '7, 8' },
            { label: 'Services', value: '1, 2' },
        ],
        route: '/oati/core-info/point-to-point',
        btnLabel: 'View Point-to-Point Rates',
    },
    {
        icon: '🌐',
        title: 'Network Rates',
        description:
            'Manage network integration transmission service rates for firm connections and configure ancillary services including scheduling, dispatch, and voltage control pricing.',
        meta: [
            { label: 'Schedule', value: '10, 11' },
            { label: 'Services', value: '1, 2' },
        ],
        route: '/oati/core-info/network',
        btnLabel: 'View Network Rates',
    },
    {
        icon: '⚡',
        title: 'Peak Configuration',
        description:
            'Define on-peak and off-peak time periods used across all OATT computations. Configure peak days (Mon–Sun) and peak hours (00:00–24:00). Off-peak values are auto-derived.',
        meta: [
            { label: 'Applies to', value: 'All Rates' },
            { label: 'Granularity', value: 'Hourly, Daily' },
        ],
        route: '/oati/core-info/peak-config',
        btnLabel: 'Configure Peak Hours',
    },
];

const OattRatesPage = () => {
    const navigate = useNavigate();

    return (
        <PageLayout title="OATT Rates">
            <div className={styles.cardsGrid}>
                {CARDS.map((card) => (
                    <div
                        key={card.route}
                        className={styles.infoCard}
                        onClick={() => navigate(card.route)}
                        role="button"
                        aria-label={card.title}
                        data-testid="rates-card"
                        data-route={card.route}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && navigate(card.route)}
                    >
                        <div className={styles.cardHeader}>
                            <div className={styles.cardIcon}>{card.icon}</div>
                            <h2 className={styles.cardTitle}>{card.title}</h2>
                        </div>

                        <p className={styles.cardDescription}>{card.description}</p>

                        <div className={styles.cardMeta}>
                            {card.meta.map((m) => (
                                <div key={m.label} className={styles.metaItem}>
                                    <span className={styles.metaLabel}>{m.label}:</span>
                                    <span>{m.value}</span>
                                </div>
                            ))}
                        </div>

                        <button
                            className={styles.btnLink}
                            data-testid="rates-card-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(card.route);
                            }}
                        >
                            {card.btnLabel} <span>→</span>
                        </button>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
};

export default OattRatesPage;
